import dayjs from 'dayjs';

import type {DateTimeObj} from '../../../datetime';
import type {ScheduleInterval} from './types';

import {datetimeObjToISOString} from '../../../datetime';
import {SCHEDULE_SLOT_DURATION} from './constants';

export const getIntervalsFromSlots = (
  slots: {start_date: DateTimeObj}[],
  utc = false,
) => {
  const intervals: ScheduleInterval[] = [];

  if (!slots.length) {
    return intervals;
  }

  let timeSlots = slots
    .map(event => {
      const startDate = dayjs(datetimeObjToISOString(event.start_date), {utc});

      const hour = startDate.hour();
      const minute = startDate.minute();

      return hour * 60 + minute;
    })
    .sort((a, b) => a - b);

  // if we have same time from different dates
  timeSlots = Array.from(new Set(timeSlots));

  let j = 0;

  for (let i = 0; i < timeSlots.length; i++) {
    const left = timeSlots[i]!;
    const right = timeSlots[i + 1];

    if (!intervals[j]) {
      // @ts-expect-error: TODO: describy why
      intervals[j] = [left];
    }

    if (right === undefined) {
      if (intervals[j] === undefined) {
        intervals[j] = [left, left + SCHEDULE_SLOT_DURATION];
      } else {
        intervals[j]!.push(left + SCHEDULE_SLOT_DURATION);
      }
    } else {
      if (right - left === SCHEDULE_SLOT_DURATION) {
        continue;
      } else {
        intervals[j]![1] = left + SCHEDULE_SLOT_DURATION;
        j += 1;
      }
    }
  }

  return intervals;
};
